import { render, staticRenderFns } from "./Vervalkabupaten.vue?vue&type=template&id=23e33b20"
import script from "./Vervalkabupaten.vue?vue&type=script&lang=js"
export * from "./Vervalkabupaten.vue?vue&type=script&lang=js"
import style0 from "./Vervalkabupaten.vue?vue&type=style&index=0&id=23e33b20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports